import SaleDetail from "./saleDetail";
import PayPage from "@/view/nftPad/payPage";
import PaySuccess from "@/view/nftPad/paySuccess";
import BenefitGet from "@/view/nftPad/benefitGet";
import RightsOrder from "@/view/nftPad/rightsOrder";
import {OrderDetail} from "@/view/nftPad/orderDetail";
export default {
  SaleDetail,
  PayPage,
  PaySuccess,
  BenefitGet,
  RightsOrder,
  OrderDetail,
}
